import React from "react";
import "./CandidateList.css";

function CandidateList({ candidates, onSelect }) {
  return (
    <div className="candidate-list-container">
      <h2 className="candidate-list-title">Assigned Candidates</h2>

      <div className="candidate-cards-grid">
        {candidates.map((c) => (
          <div key={c.id} className="candidate-card" onClick={() => onSelect(c)}>
            <div className="candidate-name">{c.name}</div>
            <div className="candidate-email">{c.email}</div>
            <div className="candidate-phone">{c.phone ?? "Phone N/A"}</div>
            <div className="candidate-status">
              <span className={c.status === "ACTIVE" ? "badge active" : "badge inactive"}>
                {c.status}
              </span>
            </div>
            <div className="candidate-date">
              Joined: {new Date(c.createdAtUtc).toLocaleDateString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CandidateList;
